export default __webpack_public_path__ + "static/media/jobs-benefits-quality-equipment.e4e02c1c.png";